'use strict';

angular.module('mobile-apps').controller('DataImportModalController', [
	'$scope',
	'importInfo',
	'EntryMain',
	'EntryStatus',
	'LanguageEntries',
	'SweetAlert',
	'Utilities',
	'ConfigData',
	'$stateParams',
	'$timeout',
	'$rootScope',
	'$modalInstance',
	function (
		$scope,
		importInfo,
		EntryMain,
		EntryStatus,
		LanguageEntries,
		SweetAlert,
		Utilities,
		ConfigData,
		$stateParams,
		$timeout,
		$rootScope,
		$modalInstance
	) {

		$scope.importInfo = importInfo;

		$scope.data = {
			displayImportSelected: false,
			importEntries: 'selected',
			fileType: 'xliff',
			fileTypes: []
		};

		$scope.options = {
			importAll: {
				value: true,
				helpText: 'Imports and overwrites all values with information from the xliff',
				doNotSendToBackend: true,
				notActive: [
					'onlyAsDraft',
					'onlyIfTextEmpty',
					'skipLockedTranslations'
				],
				activateIfNotSet: [
					'onlyAsDraft',
					'onlyIfTextEmpty',
					'skipLockedTranslations'
				]
			},
			onlyAsDraft: {
				value: false,
				helpText: 'Import every target and draft from the xliff only in the draft field',
				notActive: [
					'importAll'
				]
			},
			onlyIfTextEmpty: {
				value: false,
				helpText: 'Do not override translations that already have values or drafts',
				notActive: [
					'importAll'
				]
			},
			skipLockedTranslations: {
				value: false,
				helpText: 'If a translation is locked do not modify it',
				notActive: [
					'importAll'
				]
			},
			changeStatus: {
				value: false,
				helpText: 'If a translation value or draft was set set its state to "Accepted" or "Needs Review" depending on your workflow',
				selectedState: 1,
				statesSort: [1, 2],
				doNotSendToBackend: true,
				states: EntryStatus.statusInformation
			},
			importIntoGroup: {
				value: false,
				helpText: 'Move key into currently active group if it already exist in another one'
			},
			forceOverwrite: {
				value: true
			},
			saveSource: {
				value: false,
				helpText: 'Saves the file name along with the imported strings, so they can be filtered and exported using this file name',
			},
			applyTags: {
				value: false,
				selectedTags: {}
			}
		};

		// Has to be identical to "defaultSettingOverwrite" in "mobile-apps.server.controller.js"
		$scope.defaultSettingOverwrite = {
			translator: {
				importAll: {
					value: false
				},
				onlyAsDraft: {
					value: true
				}
			},
			tpttranslator: {
				importAll: {
					value: false
				},
				onlyAsDraft: {
					value: true
				}
			},
			tpttester: {
				importAll: {
					value: false
				},
				onlyAsDraft: {
					value: true
				}
			}
		};

		$scope.extendedFunctions = {};

		/**
		 * Checks if the checkbox should be disabled according to the role
		 * of the current user in the app
		 * @param key The key of the checkbox that should be checked
		 */
		$scope.isDisabled = function(key) {
			if ($scope.defaultSettingOverwrite.hasOwnProperty($scope.mobileApp.roleInApp)) {
				var defaults = $scope.defaultSettingOverwrite[$scope.mobileApp.roleInApp];
				if (defaults.hasOwnProperty(key)) {
					if (defaults[key].hasOwnProperty('value')) {
						return true;
					}
				}
			}

			return false;
		};


		/**
		 * Whenever a value of a checkbox changed it makes sure that other
		 * checkboxes that are in conflict with the current one are not set.
		 * @param key The key of the checkbox that changed
		 */
		$scope.checkboxChanged = function(key) {
			// Deactivate checkboxes
			if ($scope.options.hasOwnProperty(key)) {
				var checkboxData = $scope.options[key];
				if (checkboxData.value === true && checkboxData.hasOwnProperty('notActive')) {
					checkboxData.notActive.forEach(function(keyNotActive) {
						$scope.options[keyNotActive].value = false;
					});
				}
			}

			// Activate checkboxes
			Object.keys($scope.options).forEach(function(key) {
				var checkboxData = $scope.options[key];
				if (checkboxData.hasOwnProperty('activateIfNotSet')) {
					var activateCheckbox = true;
					for (var i=0;i<checkboxData.activateIfNotSet.length;i++) {
						var checkKey = checkboxData.activateIfNotSet[i];
						if ($scope.options[checkKey].value === true) {
							activateCheckbox = false;
							break;
						}
					}
					if (activateCheckbox) {
						$scope.options[key].value = true;
					}
				}
			});
		};


		/**
		 * Sets the given status
		 */
		$scope.selectStatus = function(id) {
			$scope.options.changeStatus.selectedState = id;
		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Start importing
		 */
		$scope.startImport = function () {
			var options = {};
			Object.keys($scope.options).forEach(function(key) {
				var optionData = $scope.options[key];
				if (optionData.doNotSendToBackend === true) {
					// Skip the options we do not want to send
					return;
				}

				if(key === 'applyTags'){
					options[key] = optionData;
				} else {
					options[key] = optionData.value;
				}
			});

			// Add the state if one should be set
			if ($scope.options.changeStatus.value === true) {
				options.setStatus = $scope.options.changeStatus.selectedState;
			}

			var entries = [];
			if ($scope.data.importEntries === 'selected') {
				entries = importInfo.entries;
			}

			var returnData = {
				options: options,
				entries: entries,
				fileType: $scope.data.fileType
			};

			$modalInstance.close(returnData);
		};

		/**
		 * Returns array of currently selected entries
		*/
		$scope.getSelectedEntries = function() {
			var selectedEntries = [];
			$scope.entries.forEach(function (entry) {
				if (entry.selected === true) {
					selectedEntries.push(entry);
				}
			});

			// if(!selectedEntries.length){
			// 	selectedEntries = entries.filter(function(item){
			// 		return item.key === entryKeys[0];
			// 	});
			// }

			return selectedEntries;
		};

		/**
		 * Retrurns tag category corresponding color
		*/
		$scope.getTagCategoryColor = function (categoryName) {
			if ($scope.tagCategories && categoryName) {
				var category = $scope.tagCategories.find(function (item) { return item.name.toLowerCase() === categoryName.toLowerCase(); });
				if (category) {
					return category.color;
				}
			}
			return;
		};

		/**
		 * Updating selected tags from directive
		*/
		$scope.extendedFunctions.updateTagsPropsParent = function(applyTags, selectedTags){
			$scope.options.applyTags.value = applyTags;
			$scope.options.applyTags.selectedTags = selectedTags;
		};

		/**
		 * Initialize the needed data
		 */
		function init() {

			$scope.mobileApp = importInfo.mobileApp;

			if (importInfo.entries && importInfo.entries.length !== 0) {
				// Display user option what to import if all or only selected
				$scope.data.displayImportSelected = true;
			} else {
				// No entries given so import all
				$scope.data.importEntries = 'all';
			}

			// If there are special rules defined for the users current rule
			// apply them
			var key;
			if ($scope.defaultSettingOverwrite.hasOwnProperty($scope.mobileApp.roleInApp)) {
				var defaults = $scope.defaultSettingOverwrite[$scope.mobileApp.roleInApp];
				for (key in defaults) {
					var keyDefaults = defaults[key];
					if (keyDefaults.hasOwnProperty('value')) {
						$scope.options[key].value = keyDefaults.value;
					}
				}
			}

			// Set the options
			for (key in importInfo.options) {
			    if(key === 'changeStatus') {
                    $scope.options.changeStatus.value = !!importInfo.options.changeStatus;
                    $scope.options.changeStatus.selectedState = importInfo.options.changeStatus.selectedState || 1;
                    continue;
                }

				if ($scope.options.hasOwnProperty(key)) {
					// Key exists already so simply overwrite the value
					$scope.options[key].value = importInfo.options[key];
				} else {
					// Key does not exist yet so create a new one
					$scope.options[key] = {
						value: importInfo.options[key]
					};
				}
			}

			$scope.data.fileTypes = importInfo.fileTypes;
			$scope.data.fileType = importInfo.fileTypes[0].id;

			//the metadata fields must be set for ARB format
			if ($scope.data.fileType.indexOf('arb') !== -1) {
				let success = ['arb_type', 'arb_context', 'arb_placeholders'].every(attr => {
					return $scope.mobileApp.metadata.some(meta => meta.fieldName === attr);
				});
				if (!success) {
					let message = `For <a href="http://${ConfigData.applanga.website}docs/formats/arb" target="_blank">Flatter ARB files</a> 
						please create 'arb_type', 'arb_context', 'arb_placeholders' 
						<a href="http://${ConfigData.applanga.website}docs/advanced-features/addtional-meta-fields" target="_blank">metadata fields</a> 
						befor importing the source files.`;
					Utilities.showMessage(
						'Error',
						message,
						'error'
					);
					$scope.modalInstance.dismiss();
				}
			}
		}


		init();

	}
]);
